// @flow
import React, { useEffect } from "react";

import Hero from "./components/landing/Hero";
import MobileApp from "./components/landing/MobileApp";
import BankLogos from "./components/landing/BankLogos";
import Reviews from "./components/landing/Reviews";
import Footer from "./components/landing/Footer";

const Landing = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.src = "https://static.elfsight.com/platform/platform.js";
    script.setAttribute("data-use-service-core", "");
    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    }
  }, []);

  return (
    <>
      <style>{`body { background-color: #fff; }`}</style>
      <Hero />
      <MobileApp />
      <BankLogos />
      <Reviews />
      <Footer />
    </>
  )
}

export default Landing;
